import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const ThankYouPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Get order data from URL params (Shopify can pass these back)
  const orderTotal = searchParams.get('total');
  const orderId = searchParams.get('order_id');

  useEffect(() => {
    // Fire Purchase pixel event
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: orderTotal ? parseFloat(orderTotal) : 44.99,
        currency: 'USD',
        content_type: 'product',
        content_ids: ['nukleus-focus-powder'],
        order_id: orderId || undefined
      });
    }

    // Clear cart from localStorage after successful purchase
    localStorage.removeItem("nukleus_cart_id");
  }, [orderTotal, orderId]);

  return (
    <div 
      className="min-h-screen bg-nukleus-bg flex items-center justify-center px-4"
      data-testid="thank-you-page"
    >
      <div className="max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 rounded-full bg-nukleus-violet/20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-nukleus-violet" />
        </div>

        {/* Heading */}
        <h1 className="text-3xl md:text-4xl font-semibold text-white mb-4">
          Thank You!
        </h1>
        
        <p className="text-white/60 mb-8 leading-relaxed">
          Your order has been confirmed. You'll receive an email confirmation shortly with your tracking details.
        </p>

        {/* Order Info */}
        <div className="bg-nukleus-card rounded-2xl p-6 mb-8 border border-white/5">
          {orderId && (
            <div className="flex items-center justify-between text-sm mb-3">
              <span className="text-white/50">Order Number</span>
              <span className="text-white font-mono">{orderId}</span>
            </div>
          )}
          {orderTotal && (
            <div className="flex items-center justify-between text-sm mb-3">
              <span className="text-white/50">Order Total</span>
              <span className="text-white font-semibold">${parseFloat(orderTotal).toFixed(2)}</span>
            </div>
          )}
          <div className="flex items-center justify-between text-sm">
            <span className="text-white/50">Estimated Delivery</span>
            <span className="text-white">3-5 business days</span>
          </div>
        </div>

        {/* CTA */}
        <Button
          onClick={() => navigate("/")}
          className="bg-nukleus-violet hover:bg-nukleus-violet/90 text-white rounded-full px-8 py-6 font-semibold"
          data-testid="back-home-btn"
        >
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default ThankYouPage;
